<g99-button
  variant="medium"
  color="green"
  iconPosition="left"
  [icon]="'<i class=&quot;fas fa-check&quot;></i>'"
>
  utton
</g99-button>

<g99-button
  variant="small"
  color="transparent"
  iconPosition="left"
  [icon]="'<i class=&quot;fas fa-check&quot;></i>'"
>
  utton
</g99-button>

<g99-button variant="large" color="secondary" iconPosition="left">
  utton
</g99-button>

<g99-card variant="borderless" backgroundColor="#fff">
  <h2>Card Title with Border</h2>
  <p>
    This is a card component with a border and custom background and border
    color.
  </p>
</g99-card>

<g99-card variant="borderless" backgroundColor="#ffebee">
  <h2>Card Title Borderless</h2>
  <p>This is a borderless card component with a custom background color.</p>
</g99-card>

<p class="font-size-12 fw-700">This is a bold text with font size 12px.</p>
<p class="font-size-16 fw-400 color-gray color-red">
  This is normal weight text with font size 16px.
</p>

<h2> Tootltip example</h2>
<div class="container">
  <lib-shared-tooltip
    [tooltipContent]="tooltipTemplate"
    [tooltipPosition]="'bottom'"
    [showDelay]="1000"
    [hideDelay]="300"
  >
    <span><i class="pi pi-info-circle"></i> Hover over me</span>
  </lib-shared-tooltip>

  <ng-template #tooltipTemplate>
    <div class="flex align-items-center">
      <span><b>PrimeNG</b> rocks!</span>
    </div>
  </ng-template>
</div>

<button type="button" (click)="onApiCallSuccess()">Show sucess</button>
<button type="button" (click)="onApiCallError()">Show error</button>
